/**
 * Extracted from `components/question-composer/composer-fields.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

import { cn } from "@/lib/utils"
import {
  AUTHORING_BLOOM_OPTIONS,
  AUTHORING_DIFFICULTY_OPTIONS,
  AUTHORING_REFERENCE_KIND_OPTIONS,
  authoringQuestionType,
  type AuthoringQuestionType,
  type AuthoringQuestionTypeOption,
  type AuthoringReference,
  type AuthoringReferenceKind,
} from "@/lib/library-authoring"

export const COMPOSER_INPUT_SHELL_BORDER_CLASS =
  "rounded-md border border-input bg-transparent transition-colors dark:bg-input-background"

export const INSPECTOR_PICKER_TRIGGER_CLASS = cn(
  COMPOSER_INPUT_SHELL_BORDER_CLASS,
  "group flex w-full items-center gap-3 px-3 py-2.5 text-left hover:bg-muted/40",
  "focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none",
  "disabled:cursor-not-allowed disabled:opacity-50",
)

export const MAX_BLOCKED_REASONS = 5

export function collectFormErrorMessages(errors: unknown): string[] {
  const found: string[] = []
  const walk = (node: unknown) => {
    if (!node || typeof node !== "object") return
    const message = (node as { message?: unknown }).message
    if (typeof message === "string" && message.trim()) found.push(message)
    for (const value of Object.values(node)) {
      if (value && typeof value === "object") walk(value)
    }
  }
  walk(errors)
  return Array.from(new Set(found)).slice(0, MAX_BLOCKED_REASONS)
}

export function revokeAuthoringReferencePreview(ref: AuthoringReference) {
  if (ref.previewUrl.startsWith("blob:")) {
    URL.revokeObjectURL(ref.previewUrl)
  }
}
